import { render, staticRenderFns } from "./KpiWidgetLegend.vue?vue&type=template&id=d3478fee"
import script from "./KpiWidgetLegend.vue?vue&type=script&lang=js"
export * from "./KpiWidgetLegend.vue?vue&type=script&lang=js"
import style0 from "./KpiWidgetLegend.vue?vue&type=style&index=0&id=d3478fee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports